// extracted by mini-css-extract-plugin
module.exports = {"nav":"App_nav__UeHIZ","section":"App_section__3Z15p"};